import BaseApi from './base/BaseApi';
import { GetOperation, PostOperation } from './base/operations';

export default class ProjectApi extends BaseApi {
  static entityName = 'projects';

  // fetch item without params
  fetchItem(id, withPreloader = false) {
    const iri = this.getIri(id);
    const operation = new GetOperation(iri);
    return this.execute(operation, withPreloader);
  }

  publish(id, params = {}, withPreloader = true) {
    const operation = new PostOperation(`/api/projects/${id}/publish`, params);
    return this.execute(operation, withPreloader);
  }

  archive(id, archive, withPreloader = true) {
    const action = archive ? 'archive' : 'unarchive';
    const iri = `/api/projects/${id}/${action}`;
    const operation = new PostOperation(iri, []);
    return this.execute(operation, withPreloader);
  }

  duplicate(id, props = {}, withPreloader = true) {
    const iri = `/api/projects/${id}/duplicate`;
    const operation = new PostOperation(iri, props);
    return this.execute(operation, withPreloader);
  }

  // templateId — числовой id проекта-шаблона (не IRI, в отличие от остальных
  // связей); сервер отвечает 422, если это не шаблон или в проекте уже есть разделы
  applyTemplate(id, templateId, withPreloader = true) {
    const operation = new PostOperation(`/api/projects/${id}/apply_template`, { template: templateId });
    return this.execute(operation, withPreloader);
  }

  fetchDraft() {
    const operation = new GetOperation('/api/project/draft', []);
    return this.execute(operation, true);
  }
}
